import { createContext } from 'react';
import PropTypes from 'prop-types';

import { MIconButton } from 'components/@material-extend';
import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';
import { useSnackbar } from 'notistack';

const CommonContext = createContext({
  showNotification: () => {}
});

function CommonProvider({ children }) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const showNotification = (variant, message) => {
    enqueueSnackbar(message, {
      variant,
      action: (key) => (
        <MIconButton size="small" onClick={() => closeSnackbar(key)}>
          <Icon icon={closeFill} />
        </MIconButton>
      )
    });
  };
  return <CommonContext.Provider value={{ showNotification }}>{children}</CommonContext.Provider>;
}

CommonProvider.propTypes = {
  children: PropTypes.node
};

export { CommonProvider, CommonContext };
